import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../Assets/logo.png';
import '../Styles/PaymentStatus.css';

const PaymentCancel = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [cancel, setCancel] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const sessionId = query.get('session_id');

        if (!sessionId) {
            setError('Missing session ID');
            setLoading(false);
            return;
        }

        // Simulate backend validation or logging cancelation
        const validateCancellation = async (sessionId) => {
            try {
                // Example API call to log the canceled session or validate it
                // await logCancellation(sessionId);
                setCancel(true);
            } catch (err) {
                setError('Failed to validate cancellation');
            } finally {
                setLoading(false);
            }
        };

        validateCancellation(sessionId);
    }, [location.search]);

    if (loading) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card loading-card">
                    <div className="spinner"></div>
                    <h2>Processing...</h2>
                    <p>Please wait a moment</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card error-card">
                    <div className="status-icon error-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                    </div>
                    <h1>Error</h1>
                    <p className="error-message">{error}</p>
                    <button onClick={() => navigate('/dashboard')} className="status-button error-button">
                        Return to Dashboard
                    </button>
                </div>
            </div>
        );
    }

    if (cancel) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card cancel-card">
                    <img src={logo} alt="GetQuickCare Logo" className="gqc-logo" />
                    <div className="status-icon cancel-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                    </div>
                    <h1>Payment Cancelled</h1>
                    <p className="cancel-message">
                        No worries! Your payment was cancelled and you haven't been charged.
                    </p>
                    <div className="info-box cancel-info">
                        <div className="info-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span>You can try adding your payment method again anytime</span>
                        </div>
                        <div className="info-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span>Your account is safe and secure</span>
                        </div>
                    </div>
                    <div className="button-group">
                        <button onClick={() => navigate('/dashboard')} className="status-button primary-button">
                            Return to Dashboard
                        </button>
                        <button onClick={() => navigate(-1)} className="status-button secondary-button">
                            Try Again
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-status-container">
            <div className="payment-status-card error-card">
                <div className="status-icon error-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </div>
                <h1>Failed to Process Cancellation</h1>
                <p className="error-message">
                    We encountered an issue. Please try again.
                </p>
                <button onClick={() => navigate('/dashboard')} className="status-button error-button">
                    Return to Dashboard
                </button>
            </div>
        </div>
    );
};

export default PaymentCancel;